(function (root) {
  'use strict';

  function checkoutIsReady(agreed) {
    return Boolean(agreed);
  }

  function estimateIsReady(country, postalCode) {
    return Boolean(String(country || '').trim() && String(postalCode || '').trim());
  }

  function setButtonState(button, ready) {
    if (!button) return;
    button.disabled = !ready;
    button.setAttribute('aria-disabled', ready ? 'false' : 'true');
    button.classList.toggle('is-wbl-ready', ready);
  }

  function syncCheckout(button) {
    var form = button.closest('form') || document;
    var agreement = form.querySelector('[data-agree-checkbox]');
    setButtonState(button, agreement ? checkoutIsReady(agreement.checked) : true);
  }

  function syncEstimate(button) {
    var wrapper = button.closest('[data-estimate-shipping-wrap]') || document;
    var country = wrapper.querySelector('[data-wbl-shipping-country]');
    var postalCode = wrapper.querySelector('[data-wbl-shipping-postal-code]');
    setButtonState(
      button,
      estimateIsReady(country && country.value, postalCode && postalCode.value)
    );
  }

  function bindScope(scope) {
    var checkoutButtons = scope.querySelectorAll
      ? scope.querySelectorAll('[data-wbl-checkout]')
      : [];
    var estimateButtons = scope.querySelectorAll
      ? scope.querySelectorAll('[data-wbl-estimate]')
      : [];

    checkoutButtons.forEach(syncCheckout);
    estimateButtons.forEach(syncEstimate);
  }

  function handleChange(event) {
    if (event.target.matches('[data-agree-checkbox]')) {
      var form = event.target.closest('form') || document;
      form.querySelectorAll('[data-wbl-checkout]').forEach(syncCheckout);
    }

    if (
      event.target.matches('[data-wbl-shipping-country]') ||
      event.target.matches('[data-wbl-shipping-postal-code]')
    ) {
      var wrapper = event.target.closest('[data-estimate-shipping-wrap]') || document;
      wrapper.querySelectorAll('[data-wbl-estimate]').forEach(syncEstimate);
    }
  }

  if (typeof document !== 'undefined') {
    var initialize = function () {
      bindScope(document);
      document.addEventListener('change', handleChange);
      document.addEventListener('input', handleChange);

      if (document.body && typeof MutationObserver !== 'undefined') {
        new MutationObserver(function (mutations) {
          mutations.forEach(function (mutation) {
            mutation.addedNodes.forEach(function (node) {
              if (node.nodeType === 1) bindScope(node);
            });
          });
        }).observe(document.body, { childList: true, subtree: true });
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialize, { once: true });
    } else {
      initialize();
    }
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = {
      checkoutIsReady: checkoutIsReady,
      estimateIsReady: estimateIsReady
    };
  } else {
    root.WinkyCartReadiness = {
      checkoutIsReady: checkoutIsReady,
      estimateIsReady: estimateIsReady
    };
  }
})(typeof globalThis !== 'undefined' ? globalThis : this);
